// extracted by mini-css-extract-plugin
export default {"main":"Statistics_main__ig5Eq","stat":"Statistics_stat__tafZj","statTitle":"Statistics_statTitle__G7isX","statValue":"Statistics_statValue__rYEu2"};